import { render, staticRenderFns } from "./profit-sharing-order.vue?vue&type=template&id=038f38ce"
import script from "./profit-sharing-order.vue?vue&type=script&lang=js"
export * from "./profit-sharing-order.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports